var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1920x1080",
    transform: "translate(-555.000000, -196.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error",
    transform: "translate(555.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.93478834,13.3215054 C9.64413417,13.3215054 9.40851241,13.5571271 9.40851241,13.8477813 C9.40851241,14.1384355 9.64413417,14.3740572 9.93478834,14.3740572 C10.2254425,14.3740572 10.4610643,14.1384355 10.4610643,13.8477813 C10.4610643,13.5571271 10.2254425,13.3215054 9.93478834,13.3215054 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "10.2104206 6.45114342 10.2104206 12.5392852 9.69550317 12.5392852 9.69550317 6.45114342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71165919,0.129486875 L0.0342398355,17.0649707 C-0.0636593762,17.2362944 0.0600468174,17.4494624 0.257368987,17.4494624 L19.6122077,17.4494624 C19.8095299,17.4494624 19.9332361,17.2362944 19.8353368,17.0649707 L10.1579175,0.129486875 C10.0592608,-0.0431622917 9.81031586,-0.0431622917 9.71165919,0.129486875 Z M9.93478834,0.77483871 L19.169412,16.9354839 L0.699949632,16.9354839 L9.93478834,0.77483871 Z",
    id: "Triangle"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.40ef0ecbb018b39a3f8ae9d8cc854d98.svg";
export { ForwardRef as ReactComponent };